import React from 'react';
import PropTypes from 'prop-types';

export default function TextSelectStyle() {
	return (
		{
			container: (base) => ({
				...base,
				display: 'inline-block',
				width: '100%',
			}),
			indicatorSeparator: () => ({
				display: 'none'
			}),
			dropdownIndicator: () => ({
				display: 'none'
			}),
			indicatorsContainer: () => ({
				display: 'none'
			}),
			control: () => ({
				border: 'none',
				cursor: 'default',
				transition: 'all 100ms',
				position: 'relative',
				display: 'inline-block',
				fontFamily: 'Georgia, Geneva, "Times New Roman", Times, serif',
				fontSize: '16px',
				lineHeight: '19px',
				minHeight: '19px',
			}),
			dummyInput: (base) => ({
				...base,
				display: 'none',
				position: 'absolute'
			}),
			valueContainer: (base) => ({
				...base,
				padding: 0,
				overflow: 'visible',
				minHeight: '19px',
			}),
			singleValue: () => ({}),
			placeholder: () => ({
				margin: '0 auto;'
			}),
			menu: () => ({
				top: '-2px',
				left: '50%',
				transform: 'translate(-50%)',
				position: 'absolute',
				backgroundColor: 'white',
				width: '100%',
				minWidth: '320px',
				maxWidth: '320px',
				borderRadius: '6px',
				boxShadow: '1px 1px 6px -1px #999',
				fontFamily: 'Georgia, Geneva, "Times New Roman", Times, serif',
				fontSize: '16px',
				lineHeight: '36px',
				zIndex: '2',
				textAlign: 'center'
			}),
			option: (base, {isFocused, isSelected}) => ({
				...base,
				backgroundColor: isFocused || isSelected ? "#f5f5f5" : 'white',
				color: '#333333',
				padding: '0 0 0 10px',
				'&:hover': {
					backgroundColor: "#f5f5f5"
				},
			})
		}
	)
}

// TextSelectStyle.propTypes = {
// 	buttonClassName: PropTypes.string,
// 	size: PropTypes.string,
// 	facebookScope: PropTypes.string,
// 	buttonType: PropTypes.string,
// 	layout: PropTypes.string,
// 	autoLogoutLink: PropTypes.string,
// 	useContinueAs: PropTypes.string,
// 	width: PropTypes.string,
// 	scope: PropTypes.string,
// }
// TextSelectStyle.defaultProps = {
// 	buttonClassName: `${styles.fbLoginButton} fb-login-button`,
// 	size: "large",
// 	buttonType: "continue_with",
// 	layout: "default",
// 	autoLogoutLink: "false",
// 	useContinueAs: "true",
// 	scope: "public_profile,email",
// 	width: "100%"
// }